import FilterButton from "../FilterUtililties/FilterButton";
import React, {Fragment, useRef} from "react";
import {BasicPopover} from "../../BasicPopover";
import ChannelsFilter from "./ChannelsFilter";

export default function ChannelsFilterEntry({}) {
    const ref = useRef();

    return(
        <Fragment>
            <BasicPopover
                ref={ref}
                id={'channel-filter'}
                ButtonComponent={FilterButton}>
                <ChannelsFilter handleClose={() => ref.current.close()}/>
            </BasicPopover>
        </Fragment>
    )
}

